module.exports = __webpack_public_path__ + "img/Anguilla.c0372f45.png";